// Sale Popup — show/hide with session or daily frequency gating.
(function () {
  'use strict';

  var SESSION_KEY = 'novix_sale_popup_dismissed';
  var DAILY_KEY = 'novix_sale_popup_seen_at';
  var DAY_MS = 24 * 60 * 60 * 1000;

  var activePopup = null;

  function shouldShow(popup) {
    var freq = popup.dataset.frequency || 'session';
    try {
      if (freq === 'session') {
        return !sessionStorage.getItem(SESSION_KEY);
      }
      if (freq === 'daily') {
        var last = parseInt(localStorage.getItem(DAILY_KEY), 10);
        if (!last || isNaN(last)) return true;
        return Date.now() - last >= DAY_MS;
      }
      return true;
    } catch (e) {
      return true;
    }
  }

  function markDismissed(popup) {
    var freq = popup.dataset.frequency || 'session';
    try {
      if (freq === 'session') {
        sessionStorage.setItem(SESSION_KEY, '1');
      } else if (freq === 'daily') {
        localStorage.setItem(DAILY_KEY, String(Date.now()));
      }
    } catch (e) {}
  }

  function open(popup) {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sale-popup-open');
    activePopup = popup;
    document.addEventListener('keydown', onKeyDown);
    // Move focus to close button for accessibility
    var closeBtn = popup.querySelector('.sale-popup__close');
    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }
  }

  function close(popup) {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sale-popup-open');
    markDismissed(popup);
    document.removeEventListener('keydown', onKeyDown);
    activePopup = null;
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' && activePopup) {
      close(activePopup);
    }
  }

  function init() {
    var popup = document.querySelector('[data-sale-popup]');
    if (!popup) return;
    if (!shouldShow(popup)) return;

    var delay = parseInt(popup.dataset.delay, 10);
    if (isNaN(delay) || delay < 0) delay = 4;

    setTimeout(function () {
      open(popup);
    }, delay * 1000);

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-sale-popup-close]')) {
        close(popup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
